import "./banner.scss";
import "./modal.scss";

(function () {
  let openBannerModalBtn = document.getElementById("openBannerModalBtn");
  let modalBannerCookie = $("#modalBannerCookie");
  let bannerCookieNotification = document.getElementById(
    "js-cookie-notification"
  );
  let cookieDate = localStorage.getItem("cookieDate");
  let cookieBtn = bannerCookieNotification.querySelector(".js-cookie-accept");
  let cookieModalConfirm = document.getElementById("cookieModalConfirm");

  if (bannerCookieNotification) {
    if (!cookieDate || +cookieDate + 31536000000 < Date.now()) {
      setTimeout(function () {
        bannerCookieNotification.classList.add("show");
      }, 3000);
    }
    cookieBtn.addEventListener("click", function () {
      localStorage.setItem("cookieDate", Date.now());
      bannerCookieNotification.classList.add("animating");
      bannerCookieNotification.classList.remove("show");
      setTimeout(function () {
        bannerCookieNotification.classList.remove("animating");
      }, 300);
    });
  }

  openBannerModalBtn.addEventListener("click", function () {
    modalBannerCookie.modal("show");
    bannerCookieNotification.classList.remove("show");
  });

  cookieModalConfirm.addEventListener("click", function () {
    localStorage.setItem("cookieDate", Date.now());
    cookieDate = localStorage.getItem("cookieDate");
  });

  modalBannerCookie.on("hidden.bs.modal", function () {
    if (!cookieDate) {
      bannerCookieNotification.classList.add("show");
    }
  });
})();
